import * as React from 'react';
import Timer from 'lib/Timer';

// This component exists simply to mark that the navigation list
// data has fully loaded from the Apollo server.

// this constant lets us know whether or not this is the first time
// we are mounting this component. it is globally marked as
// false as soon as we've loaded data into the cache and this
// component gets mounted.
let FIRST_APP_LOAD = true;

export const NavigationListLoadTimerConstants = {
  LAST_CHANGE_FIRST_APP_LOAD: 'app_started',
  LAST_CHANGE_SUBSEQUENT_LOAD: 'user_navigated',
  TRANSITION_KEY_FIRST_APP_LOAD: 'nav_list_from_startup',
  TRANSITION_KEY_SUBSEQUENT_LOAD: 'nav_list_from_app',
};

export default class NavigationListLoadTimer extends React.Component {
  componentDidMount() {
    const transitionKey = FIRST_APP_LOAD
      ? NavigationListLoadTimerConstants.TRANSITION_KEY_FIRST_APP_LOAD
      : NavigationListLoadTimerConstants.TRANSITION_KEY_SUBSEQUENT_LOAD;
    const lastChange = FIRST_APP_LOAD
      ? NavigationListLoadTimerConstants.LAST_CHANGE_FIRST_APP_LOAD
      : NavigationListLoadTimerConstants.LAST_CHANGE_SUBSEQUENT_LOAD;
    Timer.markChange(transitionKey, lastChange);
    FIRST_APP_LOAD = false;
  }

  render() {
    return null;
  }
}
